import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';
import { DatePicker } from '@/components/platform/forms';

interface ValuationDateSectionProps {
  date: string;
  onDateChange: (date: string) => void;
}

export function ValuationDateSection({ date, onDateChange }: ValuationDateSectionProps) {
  const { darkMode } = useDarkMode();

  return (
    <div
      className={`grid grid-cols-1 gap-x-8 gap-y-10 border-b pb-12 md:grid-cols-3 ${darkMode ? 'border-white/10' : 'border-gray-900/10'}`}
    >
      <div>
        <h2 className={`text-base/7 font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
          Valuation Date
        </h2>
        <p className={`mt-1 text-sm/6 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          Select the date for this valuation.
        </p>
      </div>

      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
        {/* data-ai-field matches the AI form bridge field name */}
        <div className="sm:col-span-4" data-ai-field="valuation_date">
          <DatePicker
            id="valuation-date"
            value={date}
            onChange={onDateChange}
            label="Date"
            required
          />
        </div>
      </div>
    </div>
  );
}
